import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'traceStatus'
})
export class TraceStatusPipe implements PipeTransform {

  transform(value: any): any {
    let status: string;
    switch (value) {
      case 0: status = '进行中'; break;
      case 1: status = '已完成'; break;
      case 2: status = '用户撤单'; break;
      case 3: status = '管理员撤单'; break;
      case 4: status = '系统撤单'; break;
      default: break;
    }
    return status;
  }

}
